import * as wf from "@qpr/client-api-workflow";
import { GETWorkflowInstanceResultData } from "@qpr/client-api-workflow/types";
import React from "react";
import { useMutation, useQueryClient } from "react-query";
const useDeleteWorkflowInstances = () => {
  const queryClient = useQueryClient();
  const invalidateCache = React.useMemo(
    () => ({
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: (query) => query.queryKey.indexOf("data-") >= 0,
        });
      },
    }),
    [queryClient]
  );
  return useMutation(async (ids: string[]) => {
    const deletePromises: Promise<GETWorkflowInstanceResultData>[] = [];

    for (let i = 0; i < ids.length; i += 1)
      deletePromises.push(wf.deleteWorkflowInstance(ids[i]));
    const delay = new Promise((resolve) => setTimeout(resolve, 2000));
    await Promise.all([...deletePromises, delay]);
  }, invalidateCache);
};

export default useDeleteWorkflowInstances;
